import React from 'react';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import general from '../../modulos/general';

import _ from 'lodash';

const ImprContr = (elemento, cliente) => {
  // console.log(cliente, empresa)

  //GENERAR PDF
  let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
  let widthDoc = (doc.internal.pageSize.width)
  let heightDoc = (doc.internal.pageSize.height)

  var imgSource1 = new Image();
  imgSource1.src = "images/contrato_1.jpeg";
  doc.convertStringToImageData(imgSource1)
  doc.addImage(imgSource1, 'PNG', 5, 5, widthDoc-10, heightDoc-10);

  let listServTarNva = [];
  let nuevaRenta = 0
  let subclase_1 = "", subclase_2 = ""
  if(elemento.tarifa.codigoTarifa){
    const elemento3 = elemento.tarifa
    elemento3.servicios.forEach((elemento, i) => {
      if(i===0){
        subclase_1 = elemento.subclaseserv.descrSubclaseServ
      }
      if(i===1){
        subclase_2 = elemento.subclaseserv.descrSubclaseServ
      }
      nuevaRenta += elemento.valorServicios
      listServTarNva.push({descripcionServicio: elemento.descripcionServicio,
        descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ,
        descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, valorServicios: elemento.valorServicios, imptos: elemento.imptos,
        valorAntesImptos: elemento.valorAntesImptos,      
        _id: i
      });
    })
  }

  let linea1DNN = ""
  let linea2DNN = ""
  let linea3DNN = ""
  if(elemento.direccion.descrTipoVia1){
    linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
    linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
    linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
    linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
    linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
    linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
    linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
    linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
    linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
    if(linea1DNN.length>40){
      linea2DNN = linea1DNN.substring(40, 80)
    }
    linea1DNN = linea1DNN.substring(0, 40)

    linea3DNN += elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio?elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio:""
    linea3DNN = linea3DNN.substring(0, 40)
  }

  doc.setFontSize(10);
  doc.setFontType("normal");
  doc.text(`${nuevaRenta}`, 15, 52.5)
  doc.text(`12`, 87, 53)
  doc.text(`${elemento.fechaCreate.substr(8, 2)}`, 43, 58)
  doc.text(`${elemento.fechaCreate.substr(5, 2)}`, 53, 58)
  doc.text(`${elemento.fechaCreate.substr(2, 2)}`, 63, 58)
  doc.text(`X`, 42.5, 72.5)

  doc.setFontSize(14);
  doc.setFontType("bold");
  doc.text(`${subclase_1}`, 15, 97)
  doc.text(`${subclase_2}`, 63, 97)

  doc.setFontSize(10);
  doc.setFontType("normal");
  doc.text(`Contrato: ${cliente.contrato}`, 10, 130)
  doc.text(`Nombres: ${cliente.nombreCliente}`, 10, 139)
  doc.text(`Apellidos: ${cliente.apellidoCliente}`, 10, 148)
  doc.text(`Documento de identidad: ${cliente.tipodoc.codigoTipoDoc} ${cliente.numeroDoc}`, 10, 157)
  doc.text(`Dirección:`, 10, 161)
  doc.setFontSize(9);
  doc.text(`${linea1DNN}`, 27, 161)
  doc.text(`${linea2DNN}`, 27, 166)
  doc.text(`Barrio:`, 10, 175)
  doc.text(`${linea3DNN}`, 27, 175)

  doc.setFontSize(10);
  doc.text(`Teléfono 1: ${cliente.telefono1}`, 10, 182)
  doc.text(`Teléfono 2: ${cliente.telefono2}`, 10, 189)
  doc.text(`Teléfono 3: ${cliente.telefono3}`, 10, 198)
  doc.text(`Correo electrónico: ${cliente.eMail}`, 10, 207)
  doc.text(`Referencia 1:`, 10, 211)
  doc.text(`${cliente.referencia1}`, 35, 211)
  doc.text(`${cliente.telefonoRef1}`, 35, 220)
  doc.text(`Referencia 2:`, 10, 224)
  doc.text(`${cliente.referencia2}`, 35, 224)
  doc.text(`${cliente.telefonoRef2}`, 35, 228)

  doc.setFontSize(7);
  let linea = 53
  for(let i=0; i<elemento.tarifa.servicios.length; i++){
    doc.text(`${elemento.tarifa.servicios[i].descripcionServicio.substring(0, 25)}`, 110, linea)
    doc.text(`${elemento.tarifa.servicios[i].valorServicios}`, 143, linea)
    linea += 6
    if(i===2){
      i = elemento.tarifa.servicios.length
    }
  }
  doc.text(`${nuevaRenta}`, 143, 71)
  doc.setFontSize(10);

  doc.addPage()

  var imgSource2 = new Image();
  imgSource2.src = "images/contrato_2.jpeg";
  doc.convertStringToImageData(imgSource2)
  doc.addImage(imgSource2, 'PNG', 5, 5, widthDoc-10, heightDoc-10);

  // let nameDoc = `OS-${listOS.numeroOS}.pdf`
  doc.autoPrint({variant: 'non-conform'});
  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
  // => UTILIZAR
  const pdfBlob = doc.output('blob');
  const url = URL.createObjectURL(pdfBlob);
  window.open(url);
  // doc.save(nameDoc)
}

export default ImprContr